import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind class merger used by every primitive. Accepts arbitrarily
 * nested arrays / conditionals and dedupes conflicting Tailwind utility
 * classes via `tailwind-merge` so consumers can pass `className`
 * overrides without worrying about specificity.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
